import Alert from '@mui/material/Alert'
import CheckCircle from '@mui/icons-material/CheckCircle'

import useStyles from './SuccessMessage.styles'

type Props = {
    id: string,
    title?: string,
}

const defaultProps: Partial<Props> = {
    title: undefined,
}

const SuccessMessage = ({
    id, title,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    return (
        <Alert
            key={`success-${id}`}
            variant="filled"
            severity="success"
            data-testid="alert-success"
            icon={(
                <div className={classes.iconWrapper}>
                    <CheckCircle fontSize="inherit" />
                </div>
            )}
        >
            {title || 'We have saved your updates'}
        </Alert>
    )
}

SuccessMessage.defaultProps = defaultProps

export default SuccessMessage
